import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { ApiService } from 'src/core/http/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class FacilityService {

    constructor(private apiService: ApiService) {}


    public getFacilities(startIndex = 0, pageSize = 40, sorting = '', search = '', searchOnDescriptionYN = false, status = 'active'): Observable<any> {
      const searchParams = new HttpParams()
      .set('startIndex', startIndex.toString())
      .set('pageSize', pageSize.toString())
      .set('sorting', sorting)
      .set('search', search)
      .set('searchOnDescriptionYN', searchOnDescriptionYN.toString())
      .set('status', status);

      return this.apiService.Get('facilities', searchParams);
    }


    public getFacility(facilityId): Observable<any> {
      return this.apiService.Get('facilities/' + facilityId);
    }


    public create(facility: any): Observable<any> {
      return this.apiService.Post('facilities', facility);
    }


    public update(facilityId, facility: any): Observable<any> {
      const searchParams = new HttpParams()
      .set('facilityId', facilityId.toString());

      return this.apiService.Put('facilities', searchParams, facility);
    }


    public delete(facilityId): Observable<any> {
      const searchParams = new HttpParams()
      .set('facilityId', facilityId);

      return this.apiService.Delete('facilities', searchParams);
    }

}
